import { hexToHsl, getContrastingForeground } from "@tellescope/utils";

/**
 * The product card is always a light surface, so "Learn more" text must always resolve to the
 * dark token of the primary/primary-foreground pair. When the primary is light (theme flips
 * --primary-foreground to dark to stay legible on it), match that — it's the same color "Add to
 * cart" text already uses. When the primary is dark, --primary itself is already dark and
 * readable. Returns a live `var(--...)` reference (not a computed hex) so this automatically
 * tracks an org's buttonTextColor override to --primary-foreground, not just primaryColor's own
 * contrast — reuses getContrastingForeground's WCAG-AA threshold to decide light vs. dark, since
 * that's the same "is this color pale" question, just applied here to pick a token instead of a
 * literal color.
 */
export const getReadableLearnMoreColor = (primaryColorHex: string | undefined): string => {
  const hsl = primaryColorHex ? hexToHsl(primaryColorHex) : null;
  // getContrastingForeground returns a near-white foreground (l: 98) when the background passed in
  // is dark, and near-black (l: 9) when it's pale — so a light (> 50) result means primary is dark.
  const isPale = hsl ? getContrastingForeground(hsl).l < 50 : false;
  return isPale ? "hsl(var(--primary-foreground))" : "hsl(var(--primary))";
};
